import React from "react";
import { Outlet } from "react-router-dom";
import ConfigurationNavlink from "./ConfigurationNavlink";
import { ToastContainer } from "react-toastify";

const ConfigurationLayout = () => {
  // ✅ GET from parent (SalonLayout)
  // const { setPageTitle } = useOutletContext<{
  //   setPageTitle: (t: string) => void;
  // }>();

  return (
    <div className="w-full">
      <ConfigurationNavlink />

      {/* ✅ PASS AGAIN to children */}
      <Outlet />
      <ToastContainer position="top-right" autoClose={2000} />
    </div>
  );
};

export default ConfigurationLayout;